import styled from '@emotion/styled'
import {
  AppBar,
  Box,
  Button,
  Container,
  Drawer,
  IconButton,
  List,
  ListItem,
  ListItemText,
  Toolbar,
  Typography,
} from '@mui/material'
import { Link } from 'react-router-dom/cjs/react-router-dom.min'
import logo from '../assets/logo.png'
import logoMandarin from '../assets/行創有限公司中文logo.png'
import  useRWD  from '../utils/useRWD'
import { useEffect, useState } from 'react'
import MenuIcon from '@mui/icons-material/Menu'

const StyledNavTitle = styled(Typography)`
  font-family: GenYOGothic2TW;
  color: #353535;
  font-size: 18px;
  font-weight: 500;
`
const StyledA = styled.a`
  font-family: GenYOGothic2TW;
  text-decoration: none;
  color: #353535;
  &:active {
    color: #353535;
  }
`

export default function Menu() {
  const { isPC, isToplet, isPhone } = useRWD()
  const [openNav, setOpenNav] = useState(false)
  const navList = [
    {
      href: '#plans',
      title: '解決方案',
    },
    {
      href: '#cases',
      title: '應用案例',
    },
    {
      href: '#aboutus',
      title: '關於行創',
    },
    {
      href: '#contactus',
      title: '聯絡我們',
    },
  ]

  return (
    <div id="top">
      <Container maxWidth="md">
        <Toolbar>
          <StyledA href="/">
            <img
              src={logoMandarin}
              alt="行創有限公司"
              style={{ height: '3.5em' }}
            />
          </StyledA>

          {/* PC */}
          {isPC && (
            <Box
              style={{
                width: '100%',
                display: 'flex',
                justifyContent: 'flex-end',
                gap: '3em',
              }}
            >
              {navList?.map((item, i) => (
                <StyledA href={item.href} key={i}>
                  <StyledNavTitle>{item.title}</StyledNavTitle>
                </StyledA>
              ))}
            </Box>
          )}

          {/* 平板、手機 */}
          {!isPC && (
              <Box
                style={{
                  width: '100%',
                  display: 'flex',
                  justifyContent: 'flex-end',
                }}
              >
                <IconButton
                  edge="end"
                  color="inherit"
                  aria-label="menu"
                  onClick={() => setOpenNav(true)}
                >
                  <MenuIcon />
                </IconButton>

                <Drawer
                  anchor="right"
                  open={openNav}
                  onClose={() => setOpenNav(false)}
                  ModalProps={{
                      disableScrollLock: true,
                  }}
                >
                  <List sx={{ width: 200 }} onClick={() => setOpenNav(false)}>
                    {navList?.map((item, i) => (
                      <ListItem
                        key={i}
                        component="a"
                        href={item.href}
                        
                      >
                        <ListItemText primary={item.title} />
                      </ListItem>
                    ))}
                  </List>
                </Drawer>
              </Box>
            )}
        </Toolbar>
      </Container>
    </div>
  )
}
